__turbopack_context__.v({
  "body": "index-module-scss-module__6TWL4a__body",
  "button": "index-module-scss-module__6TWL4a__button",
  "exit": "index-module-scss-module__6TWL4a__exit",
  "icon": "index-module-scss-module__6TWL4a__icon",
  "item": "index-module-scss-module__6TWL4a__item",
  "link": "index-module-scss-module__6TWL4a__link",
});
